import ServiceAreaViews from './views';

function ServiceAreaContainer() {
  return <ServiceAreaViews />;
}

export default ServiceAreaContainer;
